var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card-body" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-3" }, [
                _c("div", { staticClass: "form-group m-0" }, [
                  _c("label", { attrs: { for: "" } }, [_vm._v("Выберите год")]),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.year,
                          expression: "year",
                        },
                      ],
                      staticClass: "form-control",
                      on: {
                        change: function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.year = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                      },
                    },
                    [
                      _c("option", { attrs: { value: "2016" } }, [
                        _vm._v("2016"),
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "2017" } }, [
                        _vm._v("2017"),
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "2018" } }, [
                        _vm._v("2018"),
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "2019" } }, [
                        _vm._v("2019"),
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "2020" } }, [
                        _vm._v("2020"),
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "2021" } }, [
                        _vm._v("2021"),
                      ]),
                    ]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-6 flex" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-info f-sa-end",
                    attrs: { type: "button" },
                    on: { click: _vm.uploadData },
                  },
                  [_vm._v("Загрузить")]
                ),
              ]),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-12 text-center" }, [
        _c(
          "div",
          [
            _c("pulse-loader", {
              staticClass: "text-center",
              attrs: { loading: _vm.loading, color: _vm.color },
            }),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _vm.records
        ? _c("div", { staticClass: "col-md-6" }, [
            _c("div", { staticClass: "card" }, [
              _c("div", { staticClass: "card-header" }, [
                _c("h5", [_vm._v(_vm._s(_vm.display_year - 1))]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "card-body" },
                [
                  _vm._l(_vm.records.old, function (months, index) {
                    return _c("div", [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-default w-100 h-50p",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              _vm.divShow[index] = !_vm.divShow[index]
                            },
                          },
                        },
                        [
                          _vm._v(_vm._s(_vm.allMonths[index]) + " RUB: "),
                          _c("strong", [
                            _vm._v(_vm._s(_vm.customFormat(months.rub))),
                          ]),
                          _vm._v("\n                            EUR: "),
                          _c("strong", [
                            _vm._v(_vm._s(_vm.customFormat(months.euro))),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.divShow[index]
                        ? _c(
                            "div",
                            _vm._l(months, function (day, index2) {
                              return day.rub
                                ? _c("p", [
                                    _vm._v(_vm._s(index2) + ": RUB: "),
                                    _c("strong", [
                                      _vm._v(_vm._s(_vm.customFormat(day.rub))),
                                    ]),
                                    _vm._v(" EUR: "),
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(_vm.customFormat(day.euro))
                                      ),
                                    ]),
                                  ])
                                : _vm._e()
                            }),
                            0
                          )
                        : _vm._e(),
                    ])
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-center p-t-10" }, [
                    _c("p", [
                      _vm._v("Среднее значение RUB: "),
                      _c("strong", [
                        _vm._v(_vm._s(_vm.customFormat(_vm.avarage.old.rub))),
                      ]),
                      _vm._v(" EUR: "),
                      _c("strong", [
                        _vm._v(_vm._s(_vm.customFormat(_vm.avarage.old.euro))),
                      ]),
                    ]),
                  ]),
                ],
                2
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.records
        ? _c("div", { staticClass: "col-md-6" }, [
            _c("div", { staticClass: "card" }, [
              _c("div", { staticClass: "card-header" }, [
                _c("h5", [_vm._v(_vm._s(_vm.display_year))]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "card-body" },
                [
                  _vm._l(_vm.records.new, function (months, index) {
                    return _c("div", [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-default w-100 h-50p",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              _vm.divShow[index] = !_vm.divShow[index]
                            },
                          },
                        },
                        [
                          _vm._v(_vm._s(_vm.allMonths[index]) + " RUB: "),
                          _c("strong", [
                            _vm._v(_vm._s(_vm.customFormat(months.rub))),
                          ]),
                          _vm._v("\n                            EUR: "),
                          _c("strong", [
                            _vm._v(_vm._s(_vm.customFormat(months.euro))),
                          ]),
                          _vm._v(" "),
                          months.statistic
                            ? _c(
                                "span",
                                {
                                  class: _vm.getClassByStat(
                                    months.statistic.euro
                                  ),
                                },
                                [_vm._v(_vm._s(months.statistic.euro))]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.records.new[index].forecast
                            ? _c("span", [
                                _c("br"),
                                _vm._v("Прогноз: RUB: "),
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.customFormat(
                                        _vm.records.new[index].forecast.rub
                                      )
                                    )
                                  ),
                                ]),
                                _vm._v(" EUR: "),
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.customFormat(
                                        _vm.records.new[index].forecast.euro
                                      )
                                    )
                                  ),
                                ]),
                              ])
                            : _vm._e(),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.divShow[index]
                        ? _c(
                            "div",
                            _vm._l(months, function (day, index2) {
                              return day.rub && isFinite(index2)
                                ? _c("p", [
                                    _vm._v(_vm._s(index2) + ": RUB: "),
                                    _c("strong", [
                                      _vm._v(_vm._s(_vm.customFormat(day.rub))),
                                    ]),
                                    _vm._v(" EUR: "),
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(_vm.customFormat(day.euro))
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v("R: "),
                                      _c("strong", [_vm._v(_vm._s(day.rate))]),
                                    ]),
                                    _vm._v(" "),
                                    day.statistic
                                      ? _c(
                                          "span",
                                          {
                                            class: _vm.getClassByStat(
                                              day.statistic.euro
                                            ),
                                          },
                                          [_vm._v(_vm._s(day.statistic.euro))]
                                        )
                                      : _vm._e(),
                                  ])
                                : _vm._e()
                            }),
                            0
                          )
                        : _vm._e(),
                    ])
                  }),
                  _vm._v(" "),
                  !_vm.currentYear
                    ? _c("div", { staticClass: "text-center p-t-10" }, [
                        _c("p", [
                          _vm._v("Среднее значение RUB: "),
                          _c("strong", [
                            _vm._v(
                              _vm._s(_vm.customFormat(_vm.avarage.new.rub))
                            ),
                          ]),
                          _vm._v(" EUR: "),
                          _c("strong", [
                            _vm._v(
                              _vm._s(_vm.customFormat(_vm.avarage.new.euro))
                            ),
                          ]),
                        ]),
                      ])
                    : _c("div", { staticClass: "text-center p-t-10" }, [
                        _c("p", [
                          _vm._v("Среднее значение за прошедшие месяца"),
                          _c("br"),
                          _vm._v("RUB: "),
                          _c("strong", [
                            _vm._v(
                              _vm._s(_vm.customFormat(_vm.avarage.no_all.rub))
                            ),
                          ]),
                          _vm._v(" EUR: "),
                          _c("strong", [
                            _vm._v(
                              _vm._s(_vm.customFormat(_vm.avarage.no_all.euro))
                            ),
                          ]),
                        ]),
                      ]),
                  _vm._v(" "),
                  _vm.currentYear
                    ? _c("div", { staticClass: "text-center p-t-10" }, [
                        _c("p", [
                          _vm._v("Среднее значение с прогнозом RUB: "),
                          _c("strong", [
                            _vm._v(
                              _vm._s(_vm.customFormat(_vm.avarage.new.rub))
                            ),
                          ]),
                          _vm._v(" EUR: "),
                          _c("strong", [
                            _vm._v(
                              _vm._s(_vm.customFormat(_vm.avarage.new.euro))
                            ),
                          ]),
                        ]),
                      ])
                    : _vm._e(),
                ],
                2
              ),
            ]),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }